//#region imports
import React, { useState, useMemo } from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectGateRelocationsByTimeSlot } from '_redux/slices/timeline/timeline-data';
import { selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectSelectedTask, selectSelectedTasksList, selectSelectedMultiplePAXTask } from "_redux/slices/timeline/selected-task";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectBookingType } from '_redux/slices/timeline/timeline-areas';

// custom components
import JobCard from '../job-card';

// colors
import * as TaskColors from "../../utils/colors";

//#endregion

const GateRelocationsSection = ({ timeSlot }) => {
    const [clicked, setClicked] = useState([]);

    // Memoize selector to avoid recreating on every render
    const gateRelocationSelector = useMemo(() => selectGateRelocationsByTimeSlot(timeSlot), [timeSlot]);
    const gateRelocations = useSelector(gateRelocationSelector);

    const thirtyMinLayout = useSelector(selectThirtyMinLayout);
    const jobsType = useSelector(selectBookingType);
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);
    const usedTheme = useSelector(selectUsedTheme);

    // Don't render if no gate relocations or filter excludes them
    if (!gateRelocations || gateRelocations.length === 0) return null;
    if (!jobsType?.includes("gateRelocation") && !jobsType?.includes("all")) return null;

    return (
        <div style={{ marginBottom: '4px' }}>
            {/* Header banner */}
            <div style={{
                backgroundColor: TaskColors.gateRelocationTask,
                textAlign: 'left',
                padding: '5px',
            }}>
                <span style={{
                    textAlign: 'left',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    padding: 0,
                    margin: 0,
                }}>
                    {timeSlot} Gate Relocations ({gateRelocations.length})
                </span>
            </div>

            {/* List of gate relocation jobs */}
            <div style={{ padding: '4px', margin: '2px 0' }}>
                {gateRelocations.map((job, index) => (
                    <JobCard
                        key={job._id || index}
                        job={job}
                        index={index}
                        timelineJobs={true}
                        clicked={clicked}
                        setClicked={setClicked}
                        thirtyMinLayout={thirtyMinLayout}
                        selectedTask={selectedTask}
                        selectedTasksList={selectedTasksList}
                        usedTheme={usedTheme}
                        selectedMultiplePAXTask={selectedMultiplePAXTask}
                        showFullCard={true}
                    />
                ))}
            </div>
        </div>
    );
};

export default React.memo(GateRelocationsSection);
